import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
import { Toast } from "@heroui/react";

export const Route = createRootRouteWithContext()({
  component: Router,
});

function Router() {
  return (
    <>
      <Outlet />

      <Toast.Provider />

      <TanStackRouterDevtools />
    </>
  );
}
